// Hreflang SEO tags — comunica a Google tutte le versioni linguistiche della pagina
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { ALL_LANGUAGES, absoluteUrl, isPublicPath, splitLangPath } from "../i18n/urls";

const HreflangTags = () => {
  const { pathname } = useLocation();
  const { path } = splitLangPath(pathname);
  if (!isPublicPath(path)) return null;

  return (
    <Helmet>
      {ALL_LANGUAGES.map((code) => (
        <link key={code} rel="alternate" hrefLang={code} href={absoluteUrl(path, code)} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={absoluteUrl(path, "it")} />
    </Helmet>
  );
};

export default HreflangTags;
